import React from "react"
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {push} from "react-router-redux";
import {signIn} from "../../../actions/auth-actions";
import {setNotification} from "../../../actions/notifications-actions";
import * as types from "../../../actions/types";
import {Link} from "react-router-dom";

class LecturerSignIn extends React.Component {

    constructor(params) {
        super(params);
        this.username = new React.createRef();
        this.password = new React.createRef();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.isAuthenticated) {
            let { from } = this.props.location.state || { from: { pathname: '/' } };
            nextProps.push(from);
        }
    }

    login = () => {
        this.props
            .signIn(this.username.value,this.password.value)
            .then((response) => {
                if (response.type === types.AUTH_SIGN_IN_SUCCESS) {
                    this.props.setNotification('success','Byli jste úspěšně přihlášeni.');
                } else {
                    if ( response.payload.response.error ) {
                        this.props.setNotification('warning', response.payload.response.error);
                    } else {
                        this.props.setNotification('danger','Při přihlašování došlo k chybě.');
                    }
                }
            }).catch((error) => {
                this.props.setNotification('danger','Při přihlašování došlo k chybě.');
            });
    };

    render() {
        return (
            <div className='container'>
                <h1 className='page-title'>Přihlášení</h1>
                <div className='card auth-card'>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <p>Učitel má možnost ve svém profilu sledovat všechny týmy svých žáků, u kterých je veden jako lektor.</p>
                            </div>
                            <div className='col-lg-6'>
                                <div className='form-group'>
                                    <label>Email</label>
                                    <input ref={ref => this.username = ref} placeholder='Email' className='form-control'/>
                                </div>
                                <div className='form-group'>
                                    <label>Heslo</label>
                                    <input type='password' ref={ref => this.password = ref} placeholder='Heslo' className='form-control'/>
                                </div>
                                <div className='separate'>
                                    <button onClick={this.login} className='btn btn-primary btn-block'>Přihlásit se</button>
                                </div>
                                <small>
                                    <p>Ještě nemáte účet? <Link to='/lecturers/registration'>Registrujte se</Link></p>
                                    <p>Jste kapitán týmu? <Link to='/students/sign-in'>Přihlašte se zde</Link></p>
                                    <p><Link to='/lecturers/password/request'>Zapomenuté heslo</Link></p>
                                    <span><Link to='/lecturers/confirmation'>Vyžádání potvrzení účtu</Link></span>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state,ownProps) {
    return {
        location: ownProps.location,
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        setNotification: setNotification,
        push: push,
        signIn: signIn
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(LecturerSignIn);
